import React from 'react';
import { config as theme } from '../../../../theme';
import Typography from '../../../Typography';
import UserAvatar from '../../../UserAvatar';
import { HeaderContentWrapper, TitleWrapper } from './styles';

type CardHeaderContentProps = {
  title?: string;
  username: string;
  showAvatar?: boolean;
  avatarUrl?: string;
  onUsernameClick?: (username: string) => void;
  headerButtonExists: boolean;
};

const CardHeaderContent = ({
  title,
  username,
  showAvatar = true,
  avatarUrl,
  onUsernameClick,
  headerButtonExists,
}: CardHeaderContentProps) => {
  return (
    <HeaderContentWrapper limitHeaderContentWidth={headerButtonExists}>
      {showAvatar && (
        <UserAvatar
          username={username}
          avatarUrl={avatarUrl}
          margin={[0, 12, 0, 0]}
        />
      )}

      <TitleWrapper>
        {title && (
          <Typography variant="h5" fontSize={16}>
            {title}
          </Typography>
        )}
        <Typography
          variant="utility4"
          color={theme.colors.neutral[600]}
          fontSize={14}
          onClick={() => onUsernameClick?.(username)}
        >
          {`@${username}`}
        </Typography>
      </TitleWrapper>
    </HeaderContentWrapper>
  );
};

export default CardHeaderContent;
